import {
  Button,
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalOverlay,
  ModalBody,
  Text
} from '@chakra-ui/react';
import React from 'react';

interface props {
  isOpen: boolean;
  onClose: () => void;
  dispMessage: string;
  DeleteApi: () => void;
}

export const ConfirmationDialog: React.FC<props> = (props) => {
  const { isOpen, onClose, dispMessage, DeleteApi } = props;

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='200px' maxW='400px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            項目の削除
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Text pt={4}>{dispMessage}</Text>
            <Button
              float={'right'}
              mt={6}
              ml={2}
              w={100}
              border={'1px'}
              bgColor={'white'}
              color={'blue'}
              onClick={() => onClose()}
            >
              キャンセル
            </Button>
            <Button
              float={'right'}
              mt={6}
              w={100}
              border={'1px'}
              bgColor='blue'
              color={'white'}
              _focus={{ bg: 'blue', color: 'white' }}
              _hover={{ bg: 'blue.700', color: 'white' }}
              onClick={() => {
                DeleteApi();
                onClose();
              }}
            >
              OK
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
